module.exports = __webpack_public_path__ + "static/media/ic_pc.a4de3f6b.svg";